import React, { Fragment } from 'react'
import HeadingRocket from '../heading-rocket'

const PasswordResetSuccessView = () => (
  <Fragment>
    <HeadingRocket>Reset Link Sent</HeadingRocket>
  
    <p>We&#39;ve sent a password reset link to the email address associated with your account, if it exists.</p>
    <p>Psst...if it&#39;s any help, double check your Junk Email folder if you cannot find the email.</p>
  </Fragment>
)

export default PasswordResetSuccessView



// WEBPACK FOOTER //
// ./src/password-reset/success.jsx